import {
  Device,
  FlatGroup,
  WorkcellWithWorkflowDeploymentStatus,
  WorkflowType,
} from '@automata/api/apiSchemas';
import type { Option } from '@automata/workflow-builder';
import { UnleashClient } from 'unleash-proxy-client';

export type Notify = (message: string, type: 'success' | 'error') => void;

export interface ContextI {
  currentWorkspace: {
    id: string;
    name: string;
    organizationId: string;
    slug: string;
  };
  notify: Notify;
  unleash: UnleashClient;
}

export type ModelType =
  | Device
  | FlatGroup
  | WorkcellWithWorkflowDeploymentStatus;

export enum ModelNames {
  WORKFLOW = 'workflow',
  DEVICE = 'device',
  DEVICESTATE = 'device_state',
  GROUP = 'group',
}

export enum WorkflowTypes {
  PYTHON = 'python',
  GIT = 'git',
  MAESTRO = 'maestro',
  API = 'api',
  SDK = 'sdk',
  CANVAS = 'canvas',
}

export const workflowTypesOptions: Option[] = [
  { id: WorkflowTypes.PYTHON, name: 'Script' },
  { id: WorkflowTypes.GIT, name: 'Git' },
  { id: WorkflowTypes.MAESTRO, name: 'Scheduler Configuration' },
  { id: WorkflowTypes.API, name: 'API' },
  { id: WorkflowTypes.SDK, name: 'SDK' },
  { id: WorkflowTypes.CANVAS, name: 'Canvas' },
];

export const apiWorkflowTypes: readonly WorkflowType[] = [
  WorkflowTypes.API,
  WorkflowTypes.SDK,
  WorkflowTypes.CANVAS,
] as const;

export const UIModelNames = {
  ...ModelNames,
  USER: 'user',
};
